import type { BridgeChartBar } from "../types/data";
import type { ChartLayout } from "../renderers/layout";
import type { PriceScale } from "../scales/priceScale";
import { barWidth, clamp, xForIndex } from "../scales/timeScale";

export interface CandleCoordinates {
  x: number;
  highY: number;
  lowY: number;
  openY: number;
  closeY: number;
  bodyTop: number;
  bodyHeight: number;
  candleWidth: number;
  isUp: boolean;
}

export function mapCandle(
  bar: BridgeChartBar,
  index: number,
  start: number,
  end: number,
  layout: ChartLayout,
  priceScale: PriceScale
): CandleCoordinates {
  const width = barWidth(layout, start, end);
  const candleWidth = clamp(width * 0.62, 2, 14);
  const openY = priceScale.y(bar.open);
  const closeY = priceScale.y(bar.close);
  return {
    x: xForIndex(layout, start, end, index),
    highY: priceScale.y(bar.high),
    lowY: priceScale.y(bar.low),
    openY,
    closeY,
    bodyTop: Math.min(openY, closeY),
    bodyHeight: Math.max(1, Math.abs(closeY - openY)),
    candleWidth,
    isUp: bar.close >= bar.open
  };
}
